import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Unified from "./sections/Unified";
import Mission from "./sections/Mission";
import Infrastructure from "./sections/Infrastructure";
import Ecosystem from "./sections/Ecosystem";
import Systems from "./sections/Systems";
import Upgrade from "./sections/Upgrade";
import Connect from "./sections/Connect";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Unified />
      <Mission />
      <Infrastructure />
      <Ecosystem />
      <Systems />
      <Upgrade />
      <Connect />
      <Footer />
    </div>;
}